export default __webpack_public_path__ + "static/media/260.09c34e25.jpg";